const HOME_SNAPSHOT_PREFIX = 'liwaza_home_snapshot_';

export const HOME_SNAPSHOT_TTLS_MS = {
  admissions: 45 * 60 * 1000,
  community: 8 * 60 * 1000,
  verbalProgress: 60 * 60 * 1000,
  dailyArticles: 12 * 60 * 60 * 1000,
  todayProgress: 5 * 60 * 1000,
  mandatory: 30 * 60 * 1000,
  englishReward: 30 * 60 * 1000,
};

export const homeSnapshotKey = (email) =>
  `${HOME_SNAPSHOT_PREFIX}${String(email || '').trim().toLowerCase()}`;

export const readHomeSnapshot = (email) => {
  if (!email || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(homeSnapshotKey(email));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.slices) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const isHomeSliceFresh = (
  slice,
  ttlMs,
  { dateKey, now = Date.now() } = {}
) => {
  if (!slice || typeof slice.savedAt !== 'number') return false;
  if (dateKey && slice.dateKey !== dateKey) return false;
  return now - slice.savedAt < ttlMs;
};

export const writeHomeSnapshotSlice = (
  email,
  sliceName,
  data,
  { dateKey, now = Date.now() } = {}
) => {
  if (!email || !sliceName) return null;
  const current = readHomeSnapshot(email) || { slices: {} };
  const next = {
    email: String(email).trim().toLowerCase(),
    slices: {
      ...(current.slices || {}),
      [sliceName]: {
        savedAt: now,
        ...(dateKey ? { dateKey } : {}),
        data,
      },
    },
  };
  try {
    localStorage.setItem(homeSnapshotKey(email), JSON.stringify(next));
  } catch {
    return null;
  }
  return next;
};

export const invalidateHomeMandatorySnapshot = (email) => {
  clearHomeSnapshotSlice(email, 'mandatory');
};

export const clearHomeSnapshotSlice = (email, sliceName) => {
  if (!email || !sliceName || typeof localStorage === 'undefined') return;
  const current = readHomeSnapshot(email);
  if (!current?.slices?.[sliceName]) return;
  const next = {
    ...current,
    slices: {
      ...current.slices,
    },
  };
  delete next.slices[sliceName];
  try {
    localStorage.setItem(homeSnapshotKey(email), JSON.stringify(next));
  } catch {
    // ignore
  }
};

export const clearHomeSnapshot = (email) => {
  if (!email || typeof localStorage === 'undefined') return;
  localStorage.removeItem(homeSnapshotKey(email));
};
